import services from 'services'

export default {
  fetchLive(liveInterviewId, roomCode) {
    return services.fetch(`/v1/live/${liveInterviewId}/enter/${roomCode}`)
  },

  fetchScheduledLiveData(liveInterviewId, roomCode) {
    return services.fetch(`/v1/live/${liveInterviewId}/scheduling/${roomCode}`)
  },

  createCalendarEventAndUpdateLive(liveInterviewId, roomCode, slot) {
    return services.fetch(
      `/v1/live/${liveInterviewId}/scheduling/${roomCode}/update`,
      {
        method: 'POST',
        body: { slot },
      }
    )
  },
}
